import { UiTheme } from '../../theme'

const tooltipBackground = 'rgba(35, 41, 46, 0.9)'

const tooltipArrowBorder = `7px solid ${tooltipBackground}`
const tooltipArrowEmptiness = '7px solid transparent'

const tooltipSettings = {
  transitionTimeout: 350,
}

export default (theme: UiTheme) => ({
  tooltipSettings,
  styles: {
    wrapper: {
      base: {},
    },

    tooltip: {
      base: {
        ...theme.typography.small,
        textAlign: 'left',
        display: 'block',
        lineHeight: '16px',
        position: 'fixed',
        backgroundColor: tooltipBackground,
        paddingTop: '5px',
        paddingRight: theme.settings.spacing.small,
        paddingBottom: '5px',
        paddingLeft: theme.settings.spacing.small,
        borderRadius: '5px',
        color: 'white',
        width: '100%',
        maxWidth: '180px',
        zIndex: theme.settings.zLayers.portal - 1,

        opacity: 0,
        transition: `${tooltipSettings.transitionTimeout}ms ${theme.settings.timingFunctions.easeInOutBack}`,

        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
        },
      },

      fluid: {
        maxWidth: 'none',
        width: 'auto',
      },

      visible: {
        opacity: 1,
      },

      fixedPositions: {
        top: {
          base: {
            transform: 'translateY(calc(-100% - 10px)) translateX(-50%)',
          },
          visible: {
            transform: 'translateY(-100%) translateX(-50%)',
          },
        },

        right: {
          base: {
            transform: 'translateY(-50%) translateX(10px)',
          },
          visible: {
            transform: 'translateY(-50%)',
          },
        },

        bottom: {
          base: {
            transform: 'translateX(-50%) translateY(10px)',
          },
          visible: {
            transform: 'translateX(-50%)',
          },
        },

        left: {
          base: {
            transform: 'translateY(-50%) translateX(calc(-100% - 10px))',
          },
          visible: {
            transform: 'translateY(-50%) translateX(-100%)',
          },
        },
      },
    },

    tooltipArrow: {
      base: {
        display: 'block',
        position: 'absolute',
        width: 0,
        height: 0,
      },

      top: {
        bottom: '-7px',
        left: '50%',
        borderLeft: tooltipArrowEmptiness,
        borderRight: tooltipArrowEmptiness,
        borderTop: tooltipArrowBorder,
        transform: 'translateX(-50%)',
      },
      right: {
        top: '50%',
        left: '-7px',
        borderTop: tooltipArrowEmptiness,
        borderBottom: tooltipArrowEmptiness,
        borderRight: tooltipArrowBorder,
        transform: 'translateY(-50%)',
      },
      bottom: {
        top: '-7px',
        left: '50%',
        borderLeft: tooltipArrowEmptiness,
        borderRight: tooltipArrowEmptiness,
        borderBottom: tooltipArrowBorder,
        transform: 'translateX(-50%)',
      },
      left: {
        top: '50%',
        right: '-7px',
        borderTop: tooltipArrowEmptiness,
        borderBottom: tooltipArrowEmptiness,
        borderLeft: tooltipArrowBorder,
        transform: 'translateY(-50%)',
      },
    },
  },
})
